import { Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { TenantSelectorComponent } from '../tenant-selector/tenant-selector.component';
import { HelpCenterComponent } from '../help-center/help-center.component';

@Component({
  imports: [TranslocoDirective, TenantSelectorComponent, HelpCenterComponent],
  selector: 'app-header',
  template: `
    <ng-container *transloco="let t">
      <div class="flex justify-between items-center pl-4 pr-3 gap-x-2 w-full">
        <app-tenant-selector class="min-w-52 max-w-[480px] -ml-[6px]" [borderless]="true" />
        <app-help-center />
      </div>
    </ng-container>
  `,
})
export class HeaderComponent {}
